import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        currentPath: {
            name: "home",
            path: "./",
        },
        isMobile: window.innerWidth <= 768
    },
    getters: {
        isMobile: state => state.isMobile
    },
    mutations: {
        changeRoute: function (state, obj) {
            state.currentPath = Object.assign(state.currentPath, obj);
        },
        UPDATE_MOBILE_STATUS(state) {
            state.isMobile = window.innerWidth <= 768;
        }
    },
    actions: {
        updateMobileStatus({commit}) {
            commit('UPDATE_MOBILE_STATUS');
        }
    },
    modules: {},
});
